// extracted by mini-css-extract-plugin
export default {"container":"TopLeftIcon_container__vSP2g"};